import classNames from 'classnames';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';

const THERMOMETER_WIDTH = 22;

class SecondaryNavDesktop extends React.PureComponent {
  getFadePercentages = () => {
    const { slides, activeSlideIndex } = this.props;

    let usableIndex = activeSlideIndex;

    // Visual edge cases
    if (activeSlideIndex <= 0) return 0;
    if (activeSlideIndex > slides.length) usableIndex = slides.length;

    const fadePercentage = 100 / (slides.length + 1);
    const currentFade = fadePercentage * (usableIndex + 0.75);

    return currentFade;
  };

  render() {
    const { activeSlideIndex, slides, onClick, isInverted } = this.props;

    return (
      <div className="SecondaryNavDesktop">
        <div className="SecondaryNavDesktop__thermometer-container">
          <div className="SecondaryNavDesktop__thermometer" />
          <div className="SecondaryNavDesktop__overlay" />
          <div className="SecondaryNavDesktop__sections">
            {map(slides, (slide, index) => {
              const buttonClasses = classNames('SecondaryNavDesktop__tab-button', {
                'SecondaryNavDesktop__tab-button--active': index === activeSlideIndex,
                'SecondaryNavDesktop__tab-button--inverted': isInverted === true,
              });

              return (
                <div className="SecondaryNavDesktop__tab">
                  <div className="SecondaryNavDesktop__tab-tick">
                    <button
                      className={buttonClasses}
                      onClick={() => onClick(index)}
                      key={`thermDesktop-${index}`}
                    >
                      {slide}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <style jsx>
          {`
            .SecondaryNavDesktop {
              position: fixed;
              top: 60px;
              z-index: 50;
              height: calc(100vh - 60px);
              min-height: 600px;
              width: 15%;
              padding: 100px 0;
              margin-left: 30px;
            }

            .SecondaryNavDesktop__thermometer-container {
              height: 100%;
              width: 100%;
              position: relative;
            }

            .SecondaryNavDesktop__thermometer {
              width: ${THERMOMETER_WIDTH}px;
              position: relative;
              height: 100%;
              border-radius: 11px;
              background-image: linear-gradient(
                to bottom,
                #ea8689 10%,
                #e9ab75 25%,
                #b8da96 40%,
                #80b3c0 57%,
                #7786c0 73%,
                #8f86b8 89%
              );
              box-shadow: 0 8px 14px 0 rgb(0 0 0 / 18%);
            }

            .SecondaryNavDesktop__sections {
              height: 100%;
              width: 100%;
              position: absolute;
              top: 0;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }

            .SecondaryNavDesktop__sections:before,
            .SecondaryNavDesktop__sections:after {
              content: '';
              display: block;
            }

            .SecondaryNavDesktop__tab-tick::before {
              content: '';
              display: block;
              position: absolute;
              border: solid 1px ${Theme.get('colors-white')};
              width: ${THERMOMETER_WIDTH / 2}px;
              top: 50%;
              transform: translateY(-50%);
              left: 9px;
            }

            .SecondaryNavDesktop__tab-tick {
              position: relative;
            }

            .SecondaryNavDesktop__tab {
              display: flex;
              flex-direction: column;
              justify-content: flex-end;
            }

            .SecondaryNavDesktop__overlay {
              position: absolute;
              height: 100%;
              width: inherit;
              border-radius: 10px;
              transition: all 300ms ease;
              width: ${THERMOMETER_WIDTH}px;
              top: 0;
              background: linear-gradient(
                to bottom,
                rgba(244, 244, 244, 1) ${this.getFadePercentages() - 10}%,
                rgba(244, 244, 244, 0) ${this.getFadePercentages()}%
              );
            }
          `}
        </style>
        <style jsx global>{`
          .SecondaryNavDesktop__tab-button {
            display: block;
            appearance: none;
            color: ${Theme.get('colors-white')};
            font-size: 10px;
            font-weight: ${Theme.get('font-weight-bold')};
            text-transform: uppercase;
            font-stretch: ${Theme.get('font-style-normal')};
            font-style: ${Theme.get('font-style-normal')};
            text-decoration: none;
            letter-spacing: 2px;
            background: none;
            border: none;
            outline: inherit;
            cursor: pointer;
            padding-left: 33px;
            text-align: left;
          }

          .SecondaryNavDesktop__tab-button--inverted {
            color: ${Theme.get('colors-black')};
          }

          .SecondaryNavDesktop__tab-button--active {
            text-decoration: underline;
          }
        `}</style>
      </div>
    );
  }
}

SecondaryNavDesktop.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  activeSlideIndex: PropTypes.number,
  onClick: PropTypes.func,
  isInverted: PropTypes.bool,
};

SecondaryNavDesktop.defaultProps = {
  activeSlideIndex: 0,
  onClick: () => {},
  isInverted: false,
};

export default SecondaryNavDesktop;
